import React, {useEffect, useState} from 'react';
import $ from "jquery";
import moment from "moment";
import {
    GET_COL_AGGREGATE_DATA,
    GET_COLLECTION_AGGREGATE_DATA
} from "../../../api";
import cogoToast from "cogo-toast";
import {assignment, getTeam, teamReport} from "../../../api/app";
import {capitalize} from "../../../utils/capitalize";
import DTTask from "../../../components/layout/DTTask";
import Revenue from "../../../components/analytic/Revenue";
import PieChart from "../../../components/charts/PieChart";
import formatNumber from "../../../utils/formatNumber";
import Social from "../../../components/analytic/Social";

const searchableFields = [
    { field: 'first_name', isNumeric: false },
    { field: 'last_name', isNumeric: false },
    { field: 'full_name', isNumeric: false },
    { field: 'contact_number', isNumeric: false },
    { field: 'agent.name', isNumeric: true },
    { field: 'agent.username', isNumeric: true },
    { field: 'id_number', isNumeric: false }
];

let currentDateRange = null;
let filter = {};

const TeamData = (props) => {

    const token = localStorage.getItem('jwtToken');

    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [currDateRange, setCurrDateRange] = useState(null);
    const [selectedDate, setSelectedDate] = useState(false);
    const [reset, setReset] = useState(new Date().getTime());
    const [id, setId] = useState(new Date().getTime());
    const [datatable] = useState({
        membership: false,
        agent: false,
        report: false
    });

    useEffect(() => {
        getTeam(props.match.params.id).then((response) => {
            if (!response.error) {
                setUserData(response.payload.team);
                setLoading(false);
            }
        });
    }, [reset]);

    const handleDateRangeSelect = (range) => {

    };

    const assignmentDatatable = () => {
        if(datatable.assignment) return false;
        datatable.assignment = true;

        let table = $('#assignment-table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Assignment Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "assignment",
                        searchableFields,
                        filter: {
                            ...filter,
                            admin: `ObjectId(${userData._id})`
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<span class="text-capitalize">${data.subject}</span>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.social;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            "active" : `<span class="badge badge-success tx-white">Complete</span>`,
                            "pending" : `<span class="badge badge-warning tx-white">Pending</span>`
                        }[data.status];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY")
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_task"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link delete_assignment"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete_assignment', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this assignment?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                assignment("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        $('#assignment-table').DataTable().ajax.reload(null, false);
                        cogoToast.success("Assignment successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.view_task', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();
            setId(extract_td.raw._id);
            $("#modalLeaderboard").modal("show");
        });

        $('#assignment-table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Task:</td>' +
                '<td>' +
                d.raw.description +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Type:</td>' +
                '<td class="text-capitalize">' +
                d.raw.type +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '</table>'
            );
        }
    }

    const userDatatable = () => {
        if(datatable.user) return false;
        datatable.user = true;

        $('#user-datatable').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting User Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "user",
                        searchableFields,
                        filter: {
                            admin: `ObjectId(${userData._id})`
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return capitalize(data.name);
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.mobile_number
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY")
                    },
                    "targets": 2
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link delete_user"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });
    }

    const handleFilterSelect = (value, name) => {
        filter = Object.assign(filter, {
            type: value
        });

        $("#tx-filter-level").text(name);
        $('#assignment-table').DataTable().ajax.reload();
    }

    if(!loading) {
        return (
            <div className="content-body">
                <div className="container-fluid pd-x-0">
                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                    <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                    <li className="breadcrumb-item"><a href="#">Team</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Details</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-none d-md-block">
                            <span className="badge badge-success tx-white">Active</span>
                        </div>
                    </div>

                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div className="media">
                            <div className="wd-100 ht-100 bg-ui-04 rounded d-flex align-items-center justify-content-center bg-white">
                                <span className="link-03 lh-0 text-center"><i style={{fontSize: 50}} className="icon ion-md-camera"></i><p className="text-center tx-color-03 mt-2 tx-13">No Photo</p></span>
                            </div>
                            <div className="media-body pd-l-25 my-auto">
                                <h5 className="mg-b-5 text-capitalize">{userData.name}</h5>
                                <p className="mg-b-3 text-capitalize">
                                    Team Leader<br/>
                                    <span className="tx-medium tx-color-02 text-capitalize">{moment(userData.createdAt).format("Do MMM, YYYY")}</span><br/>
                                </p>
                                <span className="d-block tx-13 tx-color-03">{userData.email}</span>
                            </div>
                        </div>
                    </div>

                    <div className="row row-xs">
                        <div className="col-md-12 mg-t-10">
                            <div className="nav-wrapper mg-b-20 tx-13">
                                <div>
                                    <ul id="nav_basic" className="nav nav-line nav-fill tx-medium">
                                        <li className="nav-item"><a href="#basic " className="nav-link active" data-toggle="tab"><i className="ion-md-information-circle"/> Report</a></li>
                                        <li className="nav-item"><a href="#assignment" className="nav-link" data-toggle="tab" onClick={assignmentDatatable.bind()}><i className="ion-md-person"/> Assignment</a></li>
                                        <li className="nav-item"><a href="#user" className="nav-link" data-toggle="tab" onClick={userDatatable.bind()}><i className="ion-md-person"/> App Users</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="tab-content">
                                <div id="basic" className="tab-pane fade active show">
                                    <div className="row row-sm">
                                        <Social id={userData._id}/>
                                        <Revenue id={userData._id}/>
                                    </div>
                                </div>

                                <div id="assignment" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Assignment List</h6>
                                                    <div className="d-flex tx-18">

                                                        <div className="tx-12 tx-color-03 align-items-center d-none d-sm-flex mg-r-10">
                                                            <div className="dropdown mr-2">
                                                                <a href="javascript:void(0)" className="link-01 tx-spacing-1 tx-rubik d-flex align-items-center dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-filter-level">Filter By</span></a>
                                                                <div className="dropdown-menu" aria-labelledby="dropdownSelectButton">
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "post", "Post")}>Post</a>
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "comment", "Comment")}>Comment</a>
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "report", "Report")}>Report</a>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex tx-18">
                                                                <a href="#" onClick={(e) => {e.preventDefault(); $('#assignment-table').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <table id="assignment-table" className="table" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-20p">Subject</th>
                                                            <th className="wd-20p">Social</th>
                                                            <th className="wd-20p">Status</th>
                                                            <th className="wd-20p">Date</th>
                                                            <th className="wd-20p">Actions</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="user" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">App Users</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="#" onClick={(e) => {e.preventDefault(); $('#user-datatable').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="user-datatable" className="table" width={"100%"}>
                                                        <thead>
                                                        <tr>
                                                            <th className="wd-25p">Name</th>
                                                            <th className="wd-25p">Mobile Number</th>
                                                            <th className="wd-25p">Date</th>
                                                            <th className="wd-25p">Actions</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalLeaderboard" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel6">Assignment Tasks</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => $("#tx-support-level").text("Select Date")}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <DTTask id={id}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog"
                         aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes,
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-danger btn-block mt-0"
                                            data-dismiss="modal">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="content-body">
            <div className="container d-flex justify-content-center ht-100p">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mg-t-10">Collecting Data</p>
                </div>
            </div>
        </div>
    )
};

export default TeamData;
